(($) => {
  Drupal.behaviors.program = {
    attach(context) {

      function calculateProgress(timeFrom, timeTo) {

        const now = new Date();
        
        // Přidáme 30 minut k aktuálnímu času pro testování
        // now.setMinutes(now.getMinutes() + 23);
        // const currentTime = '14' + ':' + 

        const currentTime = now.getHours().toString().padStart(2, '0') + ':' +         
                          now.getMinutes().toString().padStart(2, '0') + ':' +
                          now.getSeconds().toString().padStart(2, '0');

        // Convert times to comparable values (seconds since midnight)
        const getSeconds = (timeStr) => {
          // Handle both HH:MM and HH:MM:SS formats
          const parts = timeStr.split(':').map(Number);
          const hours = parts[0] || 0;
          const minutes = parts[1] || 0;
          const seconds = parts[2] || 0;
          return hours * 3600 + minutes * 60 + seconds;
        };

        const startSeconds = getSeconds(timeFrom);
        const endSeconds = getSeconds(timeTo);
        const currentSeconds = getSeconds(currentTime);
        
        // Calculate progress percentage
        const totalDuration = endSeconds - startSeconds;
        const elapsedDuration = currentSeconds - startSeconds;
        
        return (totalDuration > 0)
                ? ((elapsedDuration / totalDuration) * 100).toFixed(2) : 0;
      }

      function update(context) {
        const today = new Date().toISOString().slice(2, 10).replace(/-/g, '-');
        // console.log('Today:', today);// 25-09-04
        // const today = '25-09-09';
        // console.log('Today:', today);// 25-09-04

        // console.log(currentTime);

        $('.program__day__events > .row', context).each(function() {
          const $event = $(this);
          const timeFrom = $event.data('time-from');
          const timeTo = $event.data('time-to');
          const eventDate = $event.data('date');
                    
          if (eventDate === today) {
            const progress = calculateProgress(timeFrom, timeTo);            
            if (progress >= 0 && progress < 100) {
              
              $event.addClass('row--active');
              // Update progress bar if it exists
              $event.find('.progress').css('width', progress + '%');
              $event.find('.progress').prop('title', progress + '%');
            } else {              
              $event.removeClass('row--active');
            }
          } else {
            $event.removeClass('row--active');
          }
        });
      }

      if ($(context).find('.program').length === 0) {
        return false;
      }

      // Initial update
      update(context);

      // Update every second for smoother progress      
      setInterval(() => update(context), 1000);
    },
  };
})(jQuery);
